import React from 'react';
import { motion } from 'framer-motion';
import { useCountUp } from '../../hooks/useCountUp';

const StatCard = ({ label, value, icon: Icon, trend }) => {
  const displayValue = useCountUp(typeof value === 'number' ? value : 0);

  return (
    <motion.div
      whileHover={{ borderColor: 'rgba(232,25,44,0.4)' }}
      transition={{ duration: 0.2 }}
      className="zip-card p-5 flex items-start gap-4"
      style={{ boxShadow: 'none' }}
      whileHover_extra={{ boxShadow: '0 0 0 1px rgba(232,25,44,0.2)' }}
    >
      {Icon && (
        <div className="w-10 h-10 rounded-lg bg-zip-red/10 flex items-center justify-center flex-shrink-0">
          <Icon size={18} className="text-zip-red" />
        </div>
      )}
      <div className="flex-1 min-w-0">
        <div className="text-[32px] font-bold text-zip-text leading-none tracking-tight">
          {typeof value === 'number' ? displayValue.toLocaleString() : (value ?? '—')}
        </div>
        <div className="text-[13px] text-zip-muted mt-1.5 leading-snug">{label}</div>
        {trend !== undefined && (
          <div className={`text-xs mt-1 font-mono ${trend >= 0 ? 'text-emerald-600' : 'text-zip-red'}`}>
            {trend >= 0 ? '↑' : '↓'} {Math.abs(trend)}%
          </div>
        )}
      </div>
    </motion.div>
  );
};

export default StatCard;
